"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangesSmartHomeSystems = exports.ChangesPropertyDetails = void 0;
class ChangesPropertyDetails {
}
exports.ChangesPropertyDetails = ChangesPropertyDetails;
class ChangesSmartHomeSystems {
}
exports.ChangesSmartHomeSystems = ChangesSmartHomeSystems;
//# sourceMappingURL=ChangesPropertyDetails.js.map